module.exports = __webpack_public_path__ + "img/line.ceca8d82.svg";